module.exports = __webpack_public_path__ + "img/icon2.89bf2efb.svg";